import { render, staticRenderFns } from "./LayoutEx.vue?vue&type=template&id=555786c8"
import script from "./LayoutEx.vue?vue&type=script&lang=js"
export * from "./LayoutEx.vue?vue&type=script&lang=js"
import style0 from "./LayoutEx.vue?vue&type=style&index=0&id=555786c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports